import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography, Divider, Space, Button, Tag, List, Spin, Modal, message } from "antd";
import { ArrowRightOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, ExpandOutlined, EyeOutlined } from "@ant-design/icons";
import "../../assets/dist/NewApplication/ApplicantPreview.css";
import _NewapplicationService from "../../modules/NewapplicationService";
import { APP_BLOB_ROOT } from "../../constants/constants";
import _commonService from "../../modules/commonService";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from "../../constants/constants";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import ReviewCommentByApplicationIdAndSection from "./ReviewCommentByApplicationIdAndSection";
const { Text, Title } = Typography;
const { confirm } = Modal;

const ApplicationDetailsTab = ({ activeKey }) => {
  const history = useHistory();
  const [applicantDetails, setApplicantDetails] = useState({});
  const [loading, setLoading] = useState(false);

  let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");
  // const [isModalVisible, setIsModalVisible] = useState(false);
  // const [isCobModalVisible, setIsCobModalVisible] = useState(false);

  // const showCobFullScreenModal = () => setIsCobModalVisible(true);
  // const handleCobClose = () => setIsCobModalVisible(false);

  // const showApplicantFullScreenModal = () => setIsModalVisible(true);
  // const handleClose = () => setIsModalVisible(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState('');
  const [selectedDocName, setSelectedDocName] = useState('');

  // const documents = [];

  // if (applicantDetails?.UpDoc_Personal_FinStatement_Path) {
  //   documents.push("Personal Financial Statement");
  // }
  // if (applicantDetails?.UpDoc1_Patriot_Act_Form_Applicant_Path) {
  //   documents.push("Patriot Act Form (Applicant)");
  // }
  // if (applicantDetails?.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2) {
  //   documents.push("Patriot Act Form (Co-Borrower)");
  // }
  // if (applicantDetails?.UpDoc_Credit_Breau_Report_Path) {
  //   documents.push("Credit Bureau Report");
  // }
  // if (applicantDetails?.UpDoc3_Credit_Bureau_Report_CBR) {
  //   documents.push("Credit Bureau Report (Co-Borrower)");
  // }
  // if (applicantDetails?.UpDoc3_FirstTwo_Pages_Tax_Return_Path) {
  //   documents.push("First Two Pages Of Personal Tax Return");
  // }



  useEffect(() => {
    if (activeKey && activeKey == "3") {
      getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
    }
  }, [activeKey]);

  const getApplicantDetailsByID = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getApplicantInformationByApplicationId(applicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setApplicantDetails(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const getFileNameFromUrl = (url = "") => {
    try {
      return url.split("?")[0].split("/").pop();
    } catch {
      return "";
    }
  };

  // const handleDownloadPdf = (applicantDetails) => {
  //   if (!applicantDetails) return;

  //   const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const leftMargin = 40;
  //   const rightMargin = 40;

  //   // Title
  //   doc.setFontSize(16);
  //   doc.text("Loan Applicant Details", pageWidth / 2, 40, { align: "center" });

  //   doc.setFontSize(11);
  //   doc.setTextColor(100);

  //   // Applicant Info Table
  //   autoTable(doc, {
  //     startY: 70,
  //     margin: { left: leftMargin, right: rightMargin },
  //     headStyles: {
  //       fillColor: [25, 58, 106],
  //       textColor: [255, 255, 255],
  //       fontStyle: "bold",
  //     },
  //     bodyStyles: {
  //       cellPadding: 6,
  //     },
  //     columnStyles: {
  //       0: { cellWidth: 300 }, 
  //       1: { cellWidth: 'auto' },
  //     },
  //     head: [["Field", "Details"]],
  //     body: [
  //       ["Application ID", applicantDetails.ApplicationId || "-"],
  //       ["Full Name", `${applicantDetails.App_Det_FirstName} ${applicantDetails.App_Det_LastName}`],
  //       ["Email", applicantDetails.Email || "-"],
  //       ["Contact Number", applicantDetails.App_Det_ContactNumber || "-"],
  //       ["Date of Birth", applicantDetails.App_Det_DateOfBirth?.split("T")[0] || "-"],
  //       ["Loan Amount ($)", applicantDetails.App_Det_LoanAmount || "-"],
  //       ["Application Type", applicantDetails.Application_Type_Name || "-"],
  //       ["Identification Type", applicantDetails.Ident_Type || "-"],
  //       ["Identification No", applicantDetails.Ident_Identification_Number || "-"],
  //       ["Nationality", applicantDetails.Ident_Nationality || "-"],
  //       ["Address", applicantDetails.Ident_Physical_Address || "-"],
  //       ["City", applicantDetails.Ident_City || "-"],
  //       ["State", applicantDetails.Ident_State || "-"],
  //       ["Zip Code", applicantDetails.Ident_ZipCode || "-"],
  //       ["Co-Borrower Name", `${applicantDetails.CoB_FirstName || ""} ${applicantDetails.CoB_LastName || ""}`],
  //       ["Co-Borrower Relationship", applicantDetails.CoB_Relationship_With_Applicant || "-"],
  //       ["Co-Borrower Contact", applicantDetails.CoB_ContactNumber || "-"],
  //       ["Application Status", applicantDetails.Application_Status || "-"],
  //       ["CBR Score", applicantDetails.CBRScore || "-"],
  //     ],
  //   });

  //   // Save PDF with ApplicationId
  //   doc.save(`${applicantDetails.ApplicationId}_.pdf`);
  // };

  //   const handleDownloadPdf = (applicantDetails) => {
  //   if (!applicantDetails) return;

  //   const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const leftMargin = 40;
  //   const rightMargin = 40;
  //   let currentY = 40;

  //   // --- Helper to add section title ---
  //   const addSectionTitle = (title) => {
  //     doc.setFontSize(14);
  //     doc.setFont("helvetica", "bold");
  //     doc.setTextColor(25, 58, 106);
  //     doc.text(title, leftMargin, currentY);
  //     currentY += 20;
  //   };

  //   // --- Helper to draw a table ---
  //   const drawTable = (bodyData) => {
  //     autoTable(doc, {
  //       startY: currentY,
  //       margin: { left: leftMargin, right: rightMargin },
  //       headStyles: {
  //         fillColor: [25, 58, 106],
  //         textColor: [255, 255, 255],
  //         fontStyle: "bold",
  //       },
  //       bodyStyles: { cellPadding: 6, fontSize: 10 },
  //       columnStyles: { 0: { cellWidth: 300 }, 1: { cellWidth: 'auto' } },
  //       head: [["Field", "Details"]],
  //       body: bodyData,
  //       didDrawPage: (data) => { currentY = data.cursor.y + 10; }
  //     });
  //   };

  //   // ===============================
  //   // 1. APPLICANT INFORMATION
  //   // ===============================
  //   addSectionTitle("APPLICANT INFORMATION");
  //   drawTable([
  //     ["Application ID", applicantDetails.ApplicationId || "-"],
  //     ["Full Name", `${applicantDetails.App_Det_FirstName || ""} ${applicantDetails.App_Det_LastName || ""}`],
  //     ["Email", applicantDetails.Email || "-"],
  //     ["Contact Number", applicantDetails.App_Det_ContactNumber || "-"],
  //     ["Date of Birth", applicantDetails.App_Det_DateOfBirth ? applicantDetails.App_Det_DateOfBirth.split("T")[0] : "-"],
  //     ["Loan Amount ($)", applicantDetails.App_Det_LoanAmount || "-"],
  //     ["Application Type", applicantDetails.Application_Type_Name || "-"],
  //     ["Identification Type", applicantDetails.Ident_Type || "-"],
  //     ["Identification No", applicantDetails.Ident_Identification_Number || "-"],
  //     ["Nationality", applicantDetails.Ident_Nationality || "-"],
  //     ["Address", applicantDetails.Ident_Physical_Address || "-"],
  //     ["City", applicantDetails.Ident_City || "-"],
  //     ["State", applicantDetails.Ident_State || "-"],
  //     ["Zip Code", applicantDetails.Ident_ZipCode || "-"],
  //   ]);

  //   // ===============================
  //   // 2. EMPLOYMENT INFORMATION
  //   // ===============================
  //   addSectionTitle("EMPLOYMENT INFORMATION");
  //   drawTable([
  //     ["Current Employer", applicantDetails.Sp_EmployerName || "-"],
  //     ["Position", applicantDetails.Sp_PositionTitle || "-"],
  //     ["Employer Address", applicantDetails.Sp_StreetAddress || "-"],
  //     ["City", applicantDetails.Sp_City || "-"],
  //     ["State", applicantDetails.Sp_State || "-"],
  //     ["ZIP Code", applicantDetails.Sp_ZipCode || "-"],
  //     ["Phone", applicantDetails.Sp_BusinessPhone || "-"],
  //     ["Years Employed", applicantDetails.Sp_NoOfYears || "-"],
  //   ]);

  //   // ===============================
  //   // 3. CO-APPLICANT INFORMATION
  //   // ===============================
  //   addSectionTitle("Co-Borrower INFORMATION");

  //   drawTable([
  //   ["ID Type", applicantDetails.CoB_Ident_Type || "-"],
  //   ["ID Number", applicantDetails.CoB_Ident_Identification_Number || "-"],
  //   ["Date Of Issue", applicantDetails.CoB_Ident_DateOfIssue ? new Date(applicantDetails.CoB_Ident_DateOfIssue).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : "-"],
  //   ["Expiration Date", applicantDetails.CoB_Ident_ExpirationDate ? new Date(applicantDetails.CoB_Ident_ExpirationDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : "-"],
  //   ["State Of Issue", applicantDetails.CoB_Ident_State_Of_Issue || "-"],
  //   ["Nationality", applicantDetails.CoB_Ident_Nationality || "-"],
  //   ["State", applicantDetails.CoB_Ident_State || "-"],
  //   ["City", applicantDetails.CoB_Ident_City || "-"],
  //   ["Street Address", applicantDetails.CoB_Ident_Physical_Address || "-"],
  //   ["ZIP Code", applicantDetails.CoB_Ident_ZipCode || "-"],
  //   ["First Name", applicantDetails.CoB_FirstName || "-"],
  //   ["Last Name", applicantDetails.CoB_LastName || "-"],
  //   ["Date Of Birth", applicantDetails.CoB_DateOfBirth ? new Date(applicantDetails.CoB_DateOfBirth).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : "-"],
  //   ["Contact Number", applicantDetails.CoB_ContactNumber || "-"],
  //   ["Relationship With Applicant", applicantDetails.CoB_Relationship_With_Applicant || "-"],
  // ])

  //   // --- Save PDF ---
  //   doc.save(`${applicantDetails.ApplicationId || "LoanApplication"}.pdf`);
  // };



  const handleDownloadPdf = (applicantDetails) => {
    if (!applicantDetails) return;

    const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const leftMargin = 40;
    const rightMargin = 40;
    const bottomMargin = 40;
    let currentY = 70;

    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Loan Applicant Details", pageWidth / 2, 40, { align: "center" });

    // --- Helper to draw section with table name only ---
    const drawSection = (title, bodyData) => {
      const estimatedTableHeight = 20 + bodyData.length * 20;
      const spaceNeeded = 20 + estimatedTableHeight;

      if (currentY + spaceNeeded > pageHeight - bottomMargin) {
        doc.addPage();
        currentY = 40;
      }

      autoTable(doc, {
        startY: currentY,
        margin: { left: leftMargin, right: rightMargin },
        head: [[{ content: title, colSpan: 2, styles: { halign: "left" } }]],
        body: bodyData,
        headStyles: {
          fillColor: [25, 58, 106],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          halign: "left",
        },
        bodyStyles: { cellPadding: 6, fontSize: 10 },
        columnStyles: { 0: { cellWidth: 300, fontStyle: "bold" }, 1: { cellWidth: "auto" } },
        didDrawPage: (data) => { currentY = data.cursor.y + 30; },
      });
    };

    // ==============================
    // Always required → PERSONAL DETAILS
    // ==============================
    drawSection("Personal Details", [
      ["First Name", applicantDetails.App_Det_FirstName || "-"],
      ["Last Name", applicantDetails.App_Det_LastName || "-"],
      ["Date Of Birth", applicantDetails.App_Det_DateOfBirth ? new Date(applicantDetails.App_Det_DateOfBirth).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-"],
      ["Contact No.", applicantDetails.App_Det_ContactNumber || "-"],
      ["Email", applicantDetails.Email || "-"],
      ["City", applicantDetails.Ident_City || "-"],
      ["Requested Loan Amount", applicantDetails.App_Det_LoanAmount ? `$ ${Number(applicantDetails.App_Det_LoanAmount).toLocaleString()}` : "-"],
    ]);

    // ==============================
    // Conditional sections
    // ==============================
    const appType = applicantDetails.App_Det_Application_Type_Id;

    // TYPE 1 & 4 → Identification
    if (appType != 2) {
      drawSection("Identification Details", [
        ["ID Type", applicantDetails.Ident_Type || "-"],
        ["ID Number", applicantDetails.Ident_Identification_Number ? _commonService.maskLast4Digits(applicantDetails.Ident_Identification_Number) : "-"],
        ["Date Of Issue", applicantDetails.Ident_Date_Of_Issue ? new Date(applicantDetails.Ident_Date_Of_Issue).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-"],
        ["Expiration Date", applicantDetails.Ident_Expiration_Date ? new Date(applicantDetails.Ident_Expiration_Date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-"],
        ["State Of Issue", applicantDetails.Ident_State_Of_Issue || "-"],
        ["Nationality", applicantDetails.Ident_Nationality || "-"],
        ["State", applicantDetails.Ident_State || "-"],
        ["City", applicantDetails.Ident_City || "-"],
        ["Zip Code", applicantDetails.Ident_ZipCode || "-"],
        ["Street Address", applicantDetails.Ident_Physical_Address || "-"],
      ]);
    }

    // TYPE 2 & 3 → Proof Of Trust
    if (appType === 2 || appType === 3) {
      drawSection("Proof Of Trust", [
        ["Type Of Trust", applicantDetails.Trust_Type_Name || "-"],
        ["Legal Name Of The Trust", applicantDetails.Pot_Legal_Name_Of_Trust || "-"],
        ["Name Of The Grantor", applicantDetails.Pot_Name_Of_Grantor || "-"],
        ["Date Of Trust Creation", applicantDetails.Pot_Date_Of_Trust_Creation ? _commonService.convertToMMDDYYYY(applicantDetails.Pot_Date_Of_Trust_Creation) : "-"],
        ["Trust’s Tax ID (If Any)", applicantDetails.Pot_Trust_Tax_Id || "-"],
        ["State Of Trust Formation", applicantDetails.Pot_State_Of_Trust_Formation || "-"],
        ["Certificate Of Trust", applicantDetails.Pot_Certificate_Of_Trust_Path ? "Yes" : "N/A"],
      ]);
    }

    // TYPE 4 →  Co-Borrower
    if (appType === 4) {
      drawSection("Co-Borrower", [
        ["First Name", applicantDetails.CoB_FirstName || "-"],
        ["Last Name", applicantDetails.CoB_LastName || "-"],
        ["Date Of Birth", applicantDetails.CoB_DateOfBirth ? new Date(applicantDetails.CoB_DateOfBirth).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-"],
        ["Contact Number", applicantDetails.CoB_ContactNumber || "-"],
        ["Relationship With Client", applicantDetails.CoB_Relationship_With_Applicant || "-"],
      ]);

      drawSection("Co-Borrower's Identification & Address", [
        ["ID Type", applicantDetails.CoB_Ident_Type || "-"],
        ["ID Number", applicantDetails.CoB_Ident_Identification_Number ? _commonService.maskLast4Digits(applicantDetails.CoB_Ident_Identification_Number) : "-"],
        ["Date Of Issue", applicantDetails.CoB_Ident_DateOfIssue ? new Date(applicantDetails.CoB_Ident_DateOfIssue).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-"],
        ["Expiration Date", applicantDetails.CoB_Ident_ExpirationDate ? new Date(applicantDetails.CoB_Ident_ExpirationDate).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-"],
        ["State Of Issue", applicantDetails.CoB_Ident_State_Of_Issue || "-"],
        ["Nationality", applicantDetails.CoB_Ident_Nationality || "-"],
        ["State", applicantDetails.CoB_Ident_State || "-"],
        ["City", applicantDetails.CoB_Ident_City || "-"],
        ["Zip Code", applicantDetails.CoB_Ident_ZipCode || "-"],
        ["Street Address", applicantDetails.CoB_Ident_Physical_Address || "-"],
      ]);
    }


    drawSection("Documents", [
      ["Personal Financial Statement", applicantDetails?.UpDoc_Personal_FinStatement_Path ? "Yes" : "N/A"],
      ["Patriot Act Form (Applicant)", applicantDetails?.UpDoc1_Patriot_Act_Form_Applicant_Path ? "Yes" : "N/A"],
      ["Patriot Act Form (Co-Borrower)", applicantDetails?.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2 ? "Yes" : "N/A"],
      ["Credit Bureau Report", applicantDetails?.UpDoc_Credit_Breau_Report_Path ? "Yes" : "N/A"],
      ["Credit Bureau Report (Compliance Admin)", applicantDetails?.UpDoc3_Credit_Bureau_Report_CBR ? "Yes" : "N/A"],
      ["First Two Pages Of Personal Tax Return", applicantDetails?.UpDoc3_FirstTwo_Pages_Tax_Return_Path ? "Yes" : "N/A"],
      ["CBR Score", applicantDetails.CBRScore || " "],
    ]);

    // Save PDF
    doc.save(`${applicantDetails.ApplicationId || "LoanApplication"}.pdf`);
  };


  // You would call this function with your API response object:
  // handleDownloadPdf(yourApiResponseObject);


  // const handleApplicationIdentDownload = () => {
  //   if (applicantDetails?.Ident_Photo_Of_Id_Path) {
  //     setLoading(true);
  //     const fileUrl = APP_BLOB_ROOT + applicantDetails.Ident_Photo_Of_Id_Path;
  //     const fileName = applicantDetails.Ident_Photo_Of_Id_Path.split("/").pop();

  //     const link = document.createElement("a");
  //     link.href = fileUrl;
  //     link.setAttribute("download", fileName); // optional custom file name
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     setLoading(false);
  //   }
  // };

  // const handleCobIdentDownload = () => {
  //   if (applicantDetails?.CoB_Ident_Photo_Of_Id_Path) {
  //     setLoading(true);
  //     const fileUrl = APP_BLOB_ROOT + applicantDetails.CoB_Ident_Photo_Of_Id_Path;
  //     const fileName = applicantDetails.CoB_Ident_Photo_Of_Id_Path.split("/").pop();

  //     const link = document.createElement("a");
  //     link.href = fileUrl;
  //     link.setAttribute("download", fileName); // optional custom file name
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     setLoading(false);
  //   }
  // };

  const handleCertificateOfTrustDownload = () => {
    if (applicantDetails?.Pot_Certificate_Of_Trust_Path) {
      setLoading(true);
      //const fileUrl = APP_BLOB_ROOT + applicantDetails.Pot_Certificate_Of_Trust_Path;
      const fileUrl = applicantDetails.Pot_Certificate_Of_Trust_Path;
      const fileName = applicantDetails.Pot_Certificate_Of_Trust_Path.split("/").pop();

      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName); // optional custom file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoading(false);
    }
  };

  const deleteCertOfTrustDoc = () => {
    confirm({
      title: "Are you sure, want to delete this Certificate Of Trust?",
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        deleteObj();
      }
    });
  };

  const deleteObj = async () => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.deleteDocumentDataByApplicationId(localStorage.getItem("ApplicationObjId"), "certificationoftrust");
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
        getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
      } else {
        setLoading(false);
        message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const onDocumentEyeClick = (item) => {
    setSelectedDocName(item.name);
    setSelectedDocUrl(item.url);
    setIsModalVisible(true);
  };

  const onDocumentDownloadClick = (item) => {

    if (item === "Personal Financial Statement") {
      if (applicantDetails?.UpDoc_Personal_FinStatement_Path) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Personal_FinStatement_Path;
        const fileUrl = applicantDetails.UpDoc_Personal_FinStatement_Path;
        const fileName = applicantDetails.UpDoc_Personal_FinStatement_Path.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item === "Patriot Act Form (Applicant)") {
      if (applicantDetails?.UpDoc1_Patriot_Act_Form_Applicant_Path) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path;
        const fileUrl = applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path;
        const fileName = applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item == "Patriot Act Form (Co-Borrower)") {
      if (applicantDetails?.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2;
        const fileUrl = applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2;
        const fileName = applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item === "Credit Bureau Report") {
      if (applicantDetails?.UpDoc_Credit_Breau_Report_Path) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Credit_Breau_Report_Path;
        const fileUrl = applicantDetails.UpDoc_Credit_Breau_Report_Path;
        const fileName = applicantDetails.UpDoc_Credit_Breau_Report_Path.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item == "Credit Bureau Report (Compliance Admin)") {
      if (applicantDetails?.UpDoc3_Credit_Bureau_Report_CBR) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc3_Credit_Bureau_Report_CBR;
        const fileUrl = applicantDetails.UpDoc3_Credit_Bureau_Report_CBR;
        const fileName = applicantDetails.UpDoc3_Credit_Bureau_Report_CBR.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item === "First Two Pages Of Personal Tax Return") {
      if (applicantDetails?.UpDoc3_FirstTwo_Pages_Tax_Return_Path) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc3_FirstTwo_Pages_Tax_Return_Path;
        const fileUrl = applicantDetails.UpDoc3_FirstTwo_Pages_Tax_Return_Path;
        const fileName = applicantDetails.UpDoc3_FirstTwo_Pages_Tax_Return_Path.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }

    } else {
      console.error("Unknown document type:", item);
    }
  };

  const deleteDocument = (item) => {
    confirm({
      title: `Are you sure, want to delete this ${item.name}?`,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        deleteDocumentObj(item.name);
      }
    });
  };

  const deleteDocumentObj = async (item) => {
    console.log("item", item);
    setLoading(true);
    let documentType = "";
    if (item === "Personal Financial Statement") {
      documentType = "personalfinancialstatement";
    } else if (item === "Patriot Act Form (Applicant)") {
      documentType = "updoc1_patriot_act_form_applicant";
    } else if (item === "Patriot Act Form (Co-Borrower)") {
      documentType = "updoc2_patriot_act_form_coborrower_path_2";
    } else if (item === "Credit Bureau Report") {
      documentType = "credit_bureau_report";
    } else if (item === "Credit Bureau Report (Compliance Admin)") {
      documentType = "updoc3_credit_bureau_report_cbr";
    } else if (item === "First Two Pages Of Personal Tax Return") {
      documentType = "updoc3_firsttwo_pages_tax_return_path";
    } else {
      console.error("Unknown document type:", item);
    }

    try {
      const res = await _NewapplicationService.deleteDocumentDataByApplicationId(localStorage.getItem("ApplicationObjId"), documentType);
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
        getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
      } else {
        setLoading(false);
        message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };



  const onEditApplicantIdentClick = () => {
    history.push({
      pathname: routes.applicantsIdentification.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    });
  }

  const onCoBorrowerEditClick = () => {
    history.push({
      pathname: routes.coBorrowersDetails.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    });
  }

  const onIdentCoBorrowerEditClick = () => {
    history.push({
      pathname: routes.identificationOfcoBorrower.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    });
  }

  const onProofOfTrustEditClick = () => {
    history.push({
      pathname: routes.ProofOfTrust.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    });
  }

  const onDocumentsEditClick = () => {
    history.push({
      pathname: routes.uploaddocuments.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    });
  }

  const documentMap = {
    "Personal Financial Statement":
      applicantDetails?.UpDoc_Personal_FinStatement_Path,

    "Credit Bureau Report":
      applicantDetails?.UpDoc_Credit_Breau_Report_Path,

    "Credit Bureau Report (Compliance Admin)":
      applicantDetails?.UpDoc3_Credit_Bureau_Report_CBR,
  };

  const documents = Object.entries(documentMap)
    .filter(([_, path]) => !!path)
    .map(([name, path]) => ({
      name,
      url: path,
      isMulti: false,
    }));

  // Multiple-file upload fields (Multipleupload.md Section 5): Patriot Act Form (Applicant/Co-
  // Borrower) and Tax Return can now hold several files each, same as Capital Account/Liquidity
  // Statements below, so they're listed the same way instead of via documentMap above.
  if (applicantDetails?.UpDoc1_Patriot_Act_Form_Applicant_Path) {
    documents.push({
      name: "Patriot Act Form (Applicant)",
      isMulti: true,
      files: applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2) {
    documents.push({
      name: "Patriot Act Form (Co-Borrower)",
      isMulti: true,
      files: applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc3_FirstTwo_Pages_Tax_Return_Path) {
    documents.push({
      name: "First Two Pages Of Personal Tax Return",
      isMulti: true,
      files: applicantDetails.UpDoc3_FirstTwo_Pages_Tax_Return_Path
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc_Capital_Account_Statements) {
    documents.push({
      name: "Capital Account Statements",
      isMulti: true,
      files: applicantDetails.UpDoc_Capital_Account_Statements
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc_Liquidity_Statements) {
    documents.push({
      name: "Liquidity Statements",
      isMulti: true,
      files: applicantDetails.UpDoc_Liquidity_Statements
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc_AML_KYC_Docs) {
    documents.push({
      name: "AML/KYC Documents (Compliance Admin)",
      isMulti: true,
      files: applicantDetails.UpDoc_AML_KYC_Docs
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }


  // const handleView = (item) => {
  //   console.log("item", item)
  //   setSelectedDoc(APP_BLOB_ROOT + applicantDetails.UpDoc_Personal_FinStatement_Path);
  //   setIsModalVisible(true);
  // };

  console.log("A++", selectedDocUrl)

  const downloadFile = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Spin spinning={loading}>
      {APPLICATION_TYPE_ID && ["1", "3", "4"].includes(APPLICATION_TYPE_ID) && 
        <Card

          className="mb30 card-section custom-section"
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>👤</span>
                Identification Details
              </Text>
              <EditOutlined onClick={onEditApplicantIdentClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Row>
          }
        >
          {/* <Row gutter={[24, 24]}>
          <div>
            <img className="imgAlign" src={applicantDetails && (APP_BLOB_ROOT + applicantDetails.Ident_Photo_Of_Id_Path)} />
          </div>
          <Col xs={24} md={12} offset={2}>
            <Row gutter={[16, 8]}>
              <Col span={12}>
                <Text strong>ID Type:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_Application_Type}</Text>
              </Col>
              <Col span={12}>
                <Text strong>ID Number:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Identification_Number ? _commonService.maskLast4Digits(applicantDetails.Ident_Identification_Number) : null}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Date Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.Ident_Date_Of_Issue)}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Expiration Date:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.Ident_Expiration_Date)}</Text>
              </Col>
              <Col span={12}>
                <Text strong>State Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_State_Of_Issue}</Text>
              </Col>
            </Row>
          </Col>
        </Row> */}

          {/* Action Buttons */}
          {/* <Row style={{ marginTop: 16 }}>
          <Space size="large">
            <Button icon={<ExpandOutlined />} type="link" onClick={showApplicantFullScreenModal}>
              Full Screen
            </Button>
            <Button onClick={handleApplicationIdentDownload} icon={<DownloadOutlined />} type="link">
              Download
            </Button>
          </Space>
        </Row> */}
          <div>
            <Row gutter={[24, 24]} className="mt10">
              <Col xs={24} md={8}>
                <Text type="secondary">ID Type:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Type}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">ID Number:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Identification_Number ? _commonService.maskLast4Digits(applicantDetails.Ident_Identification_Number) : null}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Date Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.Ident_Date_Of_Issue)}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Expiration Date:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.Ident_Expiration_Date)}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">State Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_State_Of_Issue}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Nationality:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Nationality}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">State:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_State}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">City:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_City}</Text>
              </Col>

              <Col xs={24} md={8}>
                <Text type="secondary">Zip Code:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_ZipCode}</Text>
              </Col>
              <Col xs={24} md={16}>
                <Text type="secondary">Street Address:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Physical_Address}</Text>
              </Col>
            </Row>
          </div>
          <ReviewCommentByApplicationIdAndSection CommentSectionName="aapplicationidentification" />

        </Card>
      }

      {/* <Button onClick={() => handleDownloadPdf(applicantDetails)}>
        Download Applicant Details pdf
      </Button> */}
      {/* <Row gutter={[24, 24]} className="mb30">
        <Col xs={24} md={12}>
          <Card
            style={{
              borderRadius: "16px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}
            bodyStyle={{ padding: 24 }}
            title={
              <Row justify="space-between" align="middle">
                <Text strong>
                  <span role="img" aria-label="briefcase" style={{ marginRight: 8 }}>💼</span>
                  Professional Details
                </Text>
                <EditOutlined style={{ color: "#595959", cursor: "pointer" }} />
              </Row>
            }
          >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Row justify="space-between">
                <Text>Employment Type:</Text>
                <Text>Driving License</Text>
              </Row>
              <Row justify="space-between">
                <Text>Job Role/ Position/ Title:</Text>
                <Text>SAN156489984</Text>
              </Row>
              <Row justify="space-between">
                <Text>Company Name:</Text>
                <Text>MyProfitable Company</Text>
              </Row>
              <Row justify="space-between">
                <Text>Type Of Business:</Text>
                <Text>06th Jun 2029</Text>
              </Row>
              <Row justify="space-between">
                <Text>Years Associated:</Text>
                <Text>Texas</Text>
              </Row>
            </Space>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            style={{
              borderRadius: "16px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}
            bodyStyle={{ padding: 24 }}
            title={
              <Row justify="space-between" align="middle">
                <Text strong>
                  <span role="img" aria-label="contact" style={{ marginRight: 8 }}>📍</span>
                  Business Contact Info
                </Text>
                <EditOutlined style={{ color: "#595959", cursor: "pointer" }} />
              </Row>
            }
          >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Row justify="space-between">
                <Text>Phone:</Text>
                <Text>{applicantDetails && applicantDetails.Sp_BusinessPhone}</Text>
              </Row>
              <Row justify="space-between">
                <Text>State:</Text>
                <Text>{applicantDetails && applicantDetails.Sp_State}</Text>
              </Row>
              <Row justify="space-between">
                <Text>City:</Text>
                <Text>{applicantDetails && applicantDetails.Sp_City}</Text>
              </Row>
              <Row justify="space-between">
                <Text>Street Address:</Text>
                <Text>{applicantDetails && applicantDetails.Sp_StreetAddress}</Text>
              </Row>
              <Row justify="space-between">
                <Text>Zip Code:</Text>
                <Text>{applicantDetails && applicantDetails.Sp_ZipCode}</Text>
              </Row>
            </Space>
          </Card>
        </Col>
      </Row> */}
      {APPLICATION_TYPE_ID && APPLICATION_TYPE_ID == "4" &&
        <Card
          style={{
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
          }}
          className="mb30 card-section custom-section"
          bodyStyle={{ padding: 24 }}
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>👤</span>
                Co-Borrower
              </Text>
              <EditOutlined onClick={onCoBorrowerEditClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Row>
          }
        >
          <div>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={8}>
                <Text type="secondary">First Name:</Text><br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_FirstName}</Text>
              </Col>
              <Col xs={24} sm={8}>
                <Text type="secondary">Last Name:</Text><br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_LastName}</Text>
              </Col>
              <Col xs={24} sm={8}>
                <Text type="secondary">Date Of Birth:</Text><br />
                <Text className="b-bottm">{applicantDetails && _commonService.convertToMMDDYYYY(applicantDetails.CoB_DateOfBirth)}</Text>
              </Col>

              <Col xs={24} sm={8}>
                <Text type="secondary">Contact Number:</Text><br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_ContactNumber ? _commonService.formatUSPhoneNumber(applicantDetails.CoB_ContactNumber) : "N/A"}</Text>
              </Col>
              <Col xs={24} sm={8}>
                <Text type="secondary">Relationship With Client:</Text><br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Relationship_With_Applicant}</Text>
              </Col>
            </Row>
          </div>
          <ReviewCommentByApplicationIdAndSection CommentSectionName="coborrowerdetails" />
        </Card>
      }

      {APPLICATION_TYPE_ID && APPLICATION_TYPE_ID == "4" &&
        <Card
          className="mb30 card-section custom-section"
          bodyStyle={{ padding: 24 }}
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>👤</span>
                Co-Borrower's Identification & Address
              </Text>
              <EditOutlined onClick={onIdentCoBorrowerEditClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Row>
          }
        >
          {/* <Row gutter={[24, 24]}>
          <div>
            <img className="imgAlign" src={applicantDetails && (APP_BLOB_ROOT + applicantDetails.CoB_Ident_Photo_Of_Id_Path)} />
          </div>
          <Col xs={24} md={12} offset={2}>
            <Row gutter={[16, 8]}>
              <Col span={12}>
                <Text strong>ID Type:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Type}</Text>
              </Col>
              <Col span={12}>
                <Text strong>ID Number:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Identification_Number ? _commonService.maskLast4Digits(applicantDetails.CoB_Ident_Identification_Number) : null}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Date Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.CoB_Ident_DateOfIssue)}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Expiration Date:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.CoB_Ident_ExpirationDate)}</Text>
              </Col>
              <Col span={12}>
                <Text strong>State Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_State_Of_Issue}</Text>
              </Col>
            </Row>
          </Col>
        </Row> */}

          {/* Action Buttons */}
          {/* <Row style={{ marginTop: 16 }}>
          <Space size="large">
            <Button icon={<ExpandOutlined />} onClick={showCobFullScreenModal} type="link">
              Full Screen
            </Button>
            <Button icon={<DownloadOutlined />} onClick={handleCobIdentDownload} type="link">
              Download
            </Button>
          </Space>
        </Row> */}

          {/* Co-Resident Info */}
          {/* <Row style={{ marginTop: 24 }}>
          <Tag color="blue" style={{ marginBottom: 16 }}>
            Co-Resident
          </Tag>
        </Row> */}
          <div>
            <Row gutter={[24, 24]}>
              <Col xs={24} md={8}>
                <Text strong>ID Type:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Type}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text strong>ID Number:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Identification_Number ? _commonService.maskLast4Digits(applicantDetails.CoB_Ident_Identification_Number) : null}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text strong>Date Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.CoB_Ident_DateOfIssue)}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text strong>Expiration Date:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.CoB_Ident_ExpirationDate)}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text strong>State Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_State_Of_Issue}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Nationality:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Nationality}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">State:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Address_Type == true ? applicantDetails.Ident_State : applicantDetails.CoB_Ident_State}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">City:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Address_Type == true ? applicantDetails.Ident_City : applicantDetails.CoB_Ident_City}</Text>
              </Col>

              <Col xs={24} md={8}>
                <Text type="secondary">Zip Code:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Address_Type == true ? applicantDetails.Ident_ZipCode : applicantDetails.CoB_Ident_ZipCode}</Text>
              </Col>
              <Col xs={24} md={16}>
                <Text type="secondary">Street Address:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Address_Type == true ? applicantDetails.Ident_Physical_Address : applicantDetails.CoB_Ident_Physical_Address}</Text>
              </Col>
            </Row>
          </div>
          <ReviewCommentByApplicationIdAndSection CommentSectionName="coborroweridentification" />
        </Card>
      }

      {APPLICATION_TYPE_ID && (APPLICATION_TYPE_ID == "2" || APPLICATION_TYPE_ID == "3") &&
        <Card
          className="mb30 card-section custom-section"
          bodyStyle={{ padding: 24 }}
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>🛡️</span>
                Proof Of Trust
              </Text>
              <EditOutlined onClick={onProofOfTrustEditClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Row>
          }
        >
          {/* Info Grid */}
          <div>
            <Row gutter={[24, 16]}>
              <Col xs={24} md={8}>
                <Text type="secondary">Type Of Trust</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Trust_Type_Name}</span>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Legal Name Of The Trust</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Pot_Legal_Name_Of_Trust}</span>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Name Of The Grantor</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Pot_Name_Of_Grantor}</span>
              </Col>

              <Col xs={24} md={8}>
                <Text type="secondary">Date Of Trust Creation</Text>
                <span className="b-bottm">{applicantDetails && _commonService.convertToMMDDYYYY(applicantDetails.Pot_Date_Of_Trust_Creation)}</span>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Trust’s Tax ID (If Any)</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Pot_Trust_Tax_Id}</span>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">State Of Trust Formation</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Pot_State_Of_Trust_Formation}</span>
              </Col>
            </Row>


            {/* File Row */}
            {applicantDetails?.Pot_Certificate_Of_Trust_Path &&
              <div
                style={{
                  // background: "#f5f5f5",
                  padding: "12px 0px",
                  borderRadius: "0 0 16px 16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Space>
                  <ArrowRightOutlined />
                  <Text strong>Certificate Of Trust</Text>
                </Space>

                <Space>
                  <Button icon={<EyeOutlined />} type="text" onClick={() => onDocumentEyeClick({
                    name: "Certificate Of Trust",
                    //url: APP_BLOB_ROOT + applicantDetails.Pot_Certificate_Of_Trust_Path 
                    url: applicantDetails.Pot_Certificate_Of_Trust_Path
                  })} />
                  <Button icon={<DownloadOutlined />} type="text" target="_blank" onClick={handleCertificateOfTrustDownload} />
                  <Button
                    disabled={["1", "9"].includes(localStorage.getItem("ApplicationStatusId")) ? false : true}
                    icon={<DeleteOutlined
                      className={["1", "9"].includes(localStorage.getItem("ApplicationStatusId")) ? "" : "iconDisabledColor"} />}
                    type="text" danger onClick={() => deleteCertOfTrustDoc()}
                  />
                </Space>
              </div>
            }
          </div>
          <ReviewCommentByApplicationIdAndSection CommentSectionName="proofoftrust" />
        </Card>
      }

      {documents && documents.length > 0 &&

        <Card
          className="mb30 card-section custom-section"
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>🧾</span>
                Documents
              </Text>
              <EditOutlined onClick={onDocumentsEditClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Row>
          }
        >
          {/* Header */}
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "16px 24px",
              alignItems: "center",
            }}
          >
            <Space>
              <span role="img" aria-label="icon">📄</span>
              <Title level={5} style={{ margin: 0 }} className="ant-card-head-title"><strong>Documents</strong></Title>
            </Space>
            <EditOutlined onClick={onDocumentsEditClick} />
          </div> */}

          {/* List */}
          <div>
            <List

              dataSource={documents}
              renderItem={(item, index) => (
                <List.Item
                  className="card-section custom-section mb5"
                  style={{
                    borderBottom: index === documents.length - 1 ? "none" : "1px solid #f0f0f0",
                  }}
                  actions={
                    item.isMulti
                      ? []
                      : [
                        <Button
                          icon={<EyeOutlined />}
                          type="text"
                          key="view"
                          onClick={() => onDocumentEyeClick(item)}
                        />,
                        <Button
                          icon={<DownloadOutlined />}
                          type="text"
                          key="download"
                          onClick={() => onDocumentDownloadClick(item.name)}
                        />,
                      ]
                  }
                >
                  <div className="applicationDetailsRowAlign">
                    <Text strong style={{ width: 40 }}>{`0${index + 1}.`}</Text>

                    {item.isMulti ? (
                      <div style={{ flex: 1 }}>
                        <Text strong>{item.name}</Text>

                        <div className="applicationDetailsRowAlign-1">
                          {item.files?.map((file, idx) => (
                            <div
                              key={idx}
                              className="dividerColor applicationDetailsRowAlignDiv"
                            >
                              <Text
                                underline
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  onDocumentEyeClick({
                                    name: file.name,
                                    url: file.url,
                                  })
                                }
                              >
                                {file.name}
                              </Text>

                              <Space size={8} className="mr6">

                                <Button
                                  icon={<EyeOutlined />}
                                  type="text"
                                  key="view"
                                  onClick={() => onDocumentEyeClick({
                                    name: file.name,
                                    url: file.url,
                                  })}
                                />

                                <Divider type="vertical" />

                                <Button
                                  icon={<DownloadOutlined />}
                                  type="text"
                                  key="download"
                                  onClick={() => downloadFile(file.url, file.name)}
                                />
                              </Space>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <Text>{item.name}</Text>
                    )}
                  </div>
                </List.Item>
              )}
            />
            <Divider />
            <Row>
              <Col span={4}>
                <Text type="secondary">CBR Score:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CBRScore}</Text>
              </Col>

              <Col span={4} style={{ marginLeft: 30 }}>
                <Text type="secondary">Compliance Admin CBR Score:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CBRScore_ComplienceAdmin}</Text>
              </Col>
            </Row>


          </div>
          <ReviewCommentByApplicationIdAndSection CommentSectionName="personalfinancialstatement" />
        </Card>
      }
      <Modal
        open={isModalVisible}
        title={selectedDocName}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width="70vw" // Wider
        bodyStyle={{ height: '70vh', padding: 0 }} // Taller
        destroyOnClose
      >
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title={selectedDocName}
        />
      </Modal>

      {/* <Modal
        open={isModalVisible}
        onCancel={handleClose}
        width={800}
        centered
        footer={null}
        className="modalCenterAlign"
      >
        {applicantDetails?.Ident_Photo_Of_Id_Path && (
          <img
            src={APP_BLOB_ROOT + applicantDetails.Ident_Photo_Of_Id_Path}
            alt="Driving License"
            className="fullScreenModal"
          />
        )}
      </Modal>

      <Modal
        open={isCobModalVisible}
        onCancel={handleCobClose}
        width={800}
        centered
        footer={null}
        className="modalCenterAlign"
      >
        {applicantDetails?.CoB_Ident_Photo_Of_Id_Path && (
          <img
            src={APP_BLOB_ROOT + applicantDetails.CoB_Ident_Photo_Of_Id_Path}
            alt="Co-Borrower's Document"
            className="fullScreenModal"
          />
        )}
      </Modal> */}

    </Spin>
  )
}
export default ApplicationDetailsTab;